import { render, staticRenderFns } from "./SystemManagement.vue?vue&type=template&id=92504804&"
import script from "./SystemManagement.vue?vue&type=script&lang=ts&"
export * from "./SystemManagement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports